import React from "react";

const ConfirmUpdateIcon = ({ className = "", ...props }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M19.7929 5.29295C20.1834 4.90243 20.8164 4.90243 21.207 5.29295C21.5975 5.68348 21.5975 6.31649 21.207 6.70702L10.207 17.707C9.81643 18.0975 9.18342 18.0975 8.79289 17.707L3.79289 12.707C3.40237 12.3165 3.40237 11.6835 3.79289 11.293C4.15901 10.9268 4.73801 10.9042 5.13078 11.2246L5.20696 11.293L9.49992 15.5859L19.7929 5.29295Z"
        fill="#01BBFE"
      />
    </svg>
  );
};

export default ConfirmUpdateIcon; 